import './PieChartReport.css';
import { PieChart, d3 } from 'react-d3-components';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import ReportsDescription from '../reportsDescription/ReportsDescription';
import ChartReport from '../ChartReport';

class PieChartReport extends ChartReport {
  render() {
    const {
      title, width, height, data, description = null,
    } = this.props;
    return (
      <div className="PieChartReport report">


        <ReportsDescription title={t(title)}
          description={description}
          width={width - (width * 0.05)}
        />
        <br />
        <br />

        {!data || data === t('unableToFetchData')? ChartReport.chartStatus(width, height, data)
          : (
            <PieChart id={title}
              width={width}
              height={height}
              margin={{
                top: 10,
                bottom: 10,
                left: 100,
                right: 100,
              }}
              data={{
                values: data[0].values,
              }}
              tooltipHtml={(x, y) => `${x}: ${y}`}
              colorScale={d3.scale.category20()}
            />
          )
    }

        {data && data.length === 0 ? <span className="noData">{t('N/A')}</span> : '' }

      </div>
    );
  }
}

export default connect()(PieChartReport);
